import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import * as jwt_decode from 'jwt-decode';
import { UserService } from '../../services/user/user.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { CommonService } from 'src/app/middleware/common/common.service';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { ExcelServicesService } from 'src/app/middleware/common/excel-services.service';
import { ToastrService } from 'ngx-toastr';
import { UserprofileUpdateVM } from 'src/app/viewModels/users/userprofile-update-vm';
import { SignaturePad } from 'ngx-signaturepad/signature-pad';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UpdateUserProfileModel } from 'src/app/viewModels/users/UserListModel';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { environment } from 'src/environments/environment';
import { CustomvalidationService } from 'src/app/middleware/common/resuableServices/validatorServices';
///import { DateAdapter,MAT_DATE_FORMATS } from '@angular/material/core';
//import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
// the `default as` syntax.
//import * as _moment from 'moment';
//import {MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
//import { MAT_DATE_LOCALE } from "@angular/material/core";
//import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
  // providers: [
  //   // `MomentDateAdapter` and `MAT_MOMENT_DATE_FORMATS` can be automatically provided by importing
  //   // `MatMomentDateModule` in your applications root module. We provide it at the component level
  //   // here, due to limitations of our example generation script.
  //   {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
  //   {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
  // ],
})
export class UserProfileComponent implements OnInit {
  signOpt: string = 'draw';
  signName: string ='Surender kumar';
  signNameInitial: string = 'SK';
  selected = 'option1';
  signInitialFontFamily: any;
  addEditPin:boolean = false;
  addPin:boolean = false;
  pinAdded:boolean = false;
  isMasterPasswordLogin:boolean = false;

  
  link = [
    'https://fonts.googleapis.com/css2?family=Architects+Daughter&family=Caveat&family=Cookie&family=Dancing+Script&family=Great+Vibes&family=Pacifico&family=Parisienne&family=Sacramento&family=Satisfy&family=Yellowtail&display=swap',
    'https://fonts.googleapis.com/css2?family=Alex+Brush&family=Allura&family=Damion&family=Homemade+Apple&family=Leckerli+One&family=Mr+Dafoe&family=Nothing+You+Could+Do&family=Pinyon+Script&family=Tangerine&display=swap',
    'https://fonts.googleapis.com/css2?family=Cedarville+Cursive&family=Grand+Hotel&family=Herr+Von+Muellerhoff&family=Italianno&family=Kristi&family=Mrs+Saint+Delafield&family=Niconne&family=Norican&family=Petit+Formal+Script&family=Rochester&display=swap',
    'https://fonts.googleapis.com/css2?family=Bilbo+Swash+Caps&family=Clicker+Script&family=Dawning+of+a+New+Day&family=Euphoria+Script&family=Ma+Shan+Zheng&family=Mr+De+Haviland&family=Qwigley&family=Sofia&family=The+Girl+Next+Door&family=Zeyada&display=swap',
    'https://fonts.googleapis.com/css2?family=Beth+Ellen&family=Charmonman&family=Devonshire&family=Dr+Sugiyama&family=Engagement&family=League+Script&family=Meie+Script&family=Mr+Bedfort&family=Romanesco&family=Stalemate&family=Zhi+Mang+Xing&display=swap'
  ];
  userNotificationPreferancesID: number=0;

  addfont(){
    for (var i = 0; i < this.link.length; i++) {      
      const cssURL = this.link[i];       
      let node = document.createElement('link');
      node.href = cssURL;
      node.rel = 'stylesheet';
      const s = document.getElementsByTagName('link')[0]
      s.parentNode.insertBefore(node, s);
    }
  }

  family = [
    {font: 'Architects Daughter, cursive'},
    {font: 'Dancing Script, cursive'},
    {font: 'Pacifico, cursive'},
    {font: 'Satisfy, cursive'},
    {font: 'Caveat, cursive'},
    {font: 'Cookie, cursive'},
    {font: 'Great Vibes, cursive'},
    {font: 'Parisienne, cursive'},
    {font: 'Sacramento, cursive'},
    {font: 'Yellowtail, cursive'},

    {font: 'Alex Brush, cursive'},
    {font: 'Allura, cursive'},
    {font: 'Damion, cursive'},
    {font: 'Homemade Apple, cursive'},
    {font: 'Leckerli One, cursive'},
    {font: 'Mr Dafoe, cursive'},
    {font: 'Nothing You Could Do, cursive'},
    {font: 'Pinyon Script, cursive'},
    {font: 'Tangerine, cursive'},

    {font: 'Cedarville Cursive, cursive'},
    {font: 'Grand Hotel, cursive'},
    {font: 'Herr Von Muellerhoff, cursive'},
    {font: 'Italianno, cursive'},
    {font: 'Kristi, cursive'},
    {font: 'Niconne, cursive'},
    {font: 'Norican, cursive'},
    {font: 'Petit Formal Script, cursive'},
    {font: 'Rochester, cursive'},

    {font: 'Bilbo Swash Caps, cursive'},
    {font: 'Clicker Script, cursive'},
    {font: 'Dawning of a New Day, cursive'},
    {font: 'Euphoria Script, cursive'},
    {font: 'Ma Shan Zheng, cursive'},
    {font: 'Mr De Haviland, cursive'},
    {font: 'Qwigley, cursive'},
    {font: 'Sofia Script, cursive'},
    {font: 'The Girl Next Door, cursive'},
    {font: 'Zeyada, cursive'},


    {font: 'Beth Ellen, cursive'},
    {font: 'Charmonman, cursive'},
    {font: 'Devonshire, cursive'},
    {font: 'Dr Sugiyama, cursive'},
    {font: 'Engagement, cursive'},
    {font: 'League Script, cursive'},
    {font: 'Meie Script, cursive'},
    {font: 'Mr Bedfort, cursive'},
    {font: 'Romanesco, cursive'},
    {font: 'Stalemate, cursive'},
    {font: 'Zhi Mang Xing, cursive'},

  ]  

 
  userToken: any;
  decodedUserData: any;
  userModel = {
    userID: '',
    databaseID: 0,
    OrganizationID: 0
  }
  userManageResponseHolder: any;
  userDetails: any;
  encryptedUserToken: any;
  localUrl: any;
  cardImageBase64: string;
  isImageSaved: boolean;
  updateUserDetailResponseHolder: any;
  imageSrc: any;
  profileImage: any;
  updateUserProfileform: FormGroup;
  updateUserProfile: UpdateUserProfileModel = new UpdateUserProfileModel();
  TimeZone:string="";
  titleAlert :string="";
  userEmail:string="";
  FileName: any;
  FileExtention: any;
  ImagePathURL: string = '';
  ImagePathURLU: string = '';
  responseHolder: any;
  userName: string = '';
  userProfileID:number=0;
  currentUser: any;
  spinner:boolean=false;
  showWrapper: boolean = true;
  FullName:string="";
  FirstName :string="";
  LastName :string="";
  showLocalPanel: boolean = true;
  

  updatePasswordForm: FormGroup;
  updatePasswordResponseHolder: any; 
  UpdatePassword:boolean=false;
  hidenew = true;
  hidecurrent = true;
  hideconfirm = true;
  organizationId: string;
  databaseId: string;
  roles: string;
  phoneNumberExt: string;
  OfficeIDList: any=[];
  myOfficeID: any;
  multiFactorAuth:boolean=false;
  userIdShow:string="";
  constructor(private userService: UserService, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private commonService: CommonService,
    private constant: Constants, private statusConst: StatusConstant,
    private excelService: ExcelServicesService, private loaderService: LoaderService,
    private toastr: ToastrService, private userProfileVM: UserprofileUpdateVM,
    private _dataSharingService: DataSharingService,private dialog: MatDialog,
    private formBuilder: FormBuilder,private customValidator: CustomvalidationService) {
    this.encryptedUserToken = sessionStorage.getItem("userToken");
    this.userToken = this.encryptionAlgo.get(this.reusableClass.encryptionKey, this.encryptedUserToken)
    this.decodedUserData = jwt_decode(this.userToken);    
    this.userModel.userID = this.decodedUserData.UID;
    this.currentUser = jwt_decode(this.userToken);
    this.databaseId = sessionStorage.getItem('databaseId');
  
    this.organizationId = sessionStorage.getItem('organizationID');
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID)	
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
    this.getShortName(this.decodedUserData.Name);
    this.addfont();  
  }
  
  ngOnInit(): void {
    var roless=[];
    roless= JSON.parse(sessionStorage.getItem('roles'));
    var newArr = [];
    if(roless.length>0){
      roless.forEach((item, index) => {
        if (newArr.findIndex(i => i.roleID == item.roleID) === -1){
            newArr.push(item)
        }
       });
    }   

     if(newArr.length>0){
      this.roles = newArr.map((a: { roleName: any; }) => a.roleName).join(',');
     }else{
      this.roles="";
     }
   
     this.userIdShow= this.currentUser.UID;

    this.userModel.databaseID = parseInt(sessionStorage.getItem('databaseId'));
    this.userModel.OrganizationID = parseInt(sessionStorage.getItem('organizationID'));
    this.isMasterPasswordLogin= sessionStorage.getItem('isMasterPasswordLogin')=='true';
    this.TimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;

    this.updateUserProfileform = this.formBuilder.group({
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      email: ['', [Validators.required, Validators.pattern(emailregex)]],
      phone: [''],
     //phone: ['', [Validators.required, Validators.pattern(phoneNumberregex)]],
      address: [''],//['', Validators.required],
      dob:[''],
     //dob:['', Validators.required],
      title: [''],//['', Validators.required],
    });

    if(this.isMasterPasswordLogin){
      this.updatePasswordForm = this.formBuilder.group({
        newPassword: ['', [Validators.required, this.customValidator.checkPassword.bind(this.customValidator)]],
        confirmPassword: ['', [Validators.required, this.customValidator.checkPassword.bind(this.customValidator)]],
      });
    }else{
    this.updatePasswordForm = this.formBuilder.group({
      currentPassword: ['', [Validators.required, this.customValidator.checkPassword.bind(this.customValidator)]],
      newPassword: ['', [Validators.required, this.customValidator.checkPassword.bind(this.customValidator)]],
      confirmPassword: ['', [Validators.required, this.customValidator.checkPassword.bind(this.customValidator)]],
    });
  }
    this.addPrefix();
    this.getUserDetailsManageUser();
    this.getThirdPartyApplicationList();
    sessionStorage.setItem('HeaderModuleName', 'My Profile');   
    this._dataSharingService.sendShowFormsSiderbar('My Profile');

    if(environment.production) {
      this.showLocalPanel=false;
    }else{     
     this.showLocalPanel=true;
    }
  }

  // show default extension in Phone Number extension field
  addPrefix() {
    this.phoneNumberExt = '+1';
  }

  getUserDetailsManageUser() {
    this.loaderService.show();
    this.userService.getUserDetailsManageUser(this.userModel).subscribe(response => {
      if (response) {
        this.loaderService.hide();
        this.userManageResponseHolder = response;
        if (this.userManageResponseHolder.status == this.statusConst.statusSuccess) {
          this.userDetails = this.userManageResponseHolder.data;
          this.multiFactorAuth = this.userManageResponseHolder.data.multiFactorAuth;
          this.updateUserProfile.FirstName= this.encryptionAlgo.get(this.reusableClass.decryptionKey,this.userDetails.firstName);
          this.updateUserProfile.LastName= this.encryptionAlgo.get(this.reusableClass.decryptionKey,this.userDetails.lastName);
          this.updateUserProfile.Email=this.encryptionAlgo.get(this.reusableClass.decryptionKey,this.userDetails.email);
          this.updateUserProfile.Phone= this.encryptionAlgo.get(this.reusableClass.decryptionKey,this.userDetails.phone);
          this.updateUserProfile.Phone= this.updateUserProfile.Phone.substring(2);
          this.updateUserProfile.Address=this.userDetails.address;
          if(this.userDetails.dateOfBirth== "0001-01-01T00:00:00"){
            this.updateUserProfile.DOB="";
          }else{
            this.updateUserProfile.DOB=this.userDetails.dateOfBirth;
          } 
          if(this.userManageResponseHolder.data.userNotificationPreferancesID>0)
          {
            this.userNotificationPreferancesID =this.userManageResponseHolder.data.userNotificationPreferancesID;
            this.emailNotification=this.userManageResponseHolder.data.isEmail;
            this.textNotification=this.userManageResponseHolder.data.isText;
            this.inAppNotification=this.userManageResponseHolder.data.isInApp;
            this.checkAllNotificationStatus();
          }        
          this.updateUserProfile.Title=this.userDetails.title;
          this.userEmail=this.encryptionAlgo.get(this.reusableClass.decryptionKey,this.userDetails.email);         
          this.ImagePathURL =  (this.userDetails.profileImageUrl==null || this.userDetails.profileImageUrl==undefined || this.userDetails.profileImageUrl=='')?'':this.userDetails.profileImageUrl; // this.userDetails.profileImageUrl;
          this.ImagePathURLU =  (this.userDetails.profileImageUrl==null || this.userDetails.profileImageUrl==undefined || this.userDetails.profileImageUrl=='')?'':this.userDetails.profileImageUrl; // this.userDetails.profileImageUrl;
          this.FirstName  = this.encryptionAlgo.get(this.reusableClass.decryptionKey,this.userDetails.firstName); 
          this.LastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey,this.userDetails.lastName);
          this.FullName = this.FirstName+" "+this.LastName;
          this.userName = this.userDetails.userName;
          this.userProfileID = this.userDetails.userProfileID;
        }
        else {
          this.loaderService.hide();
        }
      }
    });
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }


  // To allow only alphabets on FirstName and LastName
  allowAlphabetOnly(event) {
		const regexp = new RegExp('^[0-9!@#$&()\\-`.+,/\"]*$');
		const result = regexp.test(event.key);
		if (result) {
      this.titleAlert = 'Please enter only alphabets';
		  event.preventDefault();
		  return false;
		}
  }

  
  onSelectFile(fileInput: any) {
    this.handleInputChange(fileInput.target.files[0]);
    var filename = fileInput.target.files[0].name;
    var name = filename.split('.'); 
    this.FileName = name[0];
    this.FileExtention = '.' + name[1];     
    this.updateUserProfileform.markAsDirty();	 
  }
 
  handleInputChange(files) {
    var file = files;
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }
    reader.onloadend = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }

  _handleReaderLoaded(e) {
    let reader = e.target;
    var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
    this.imageSrc = base64result;   
    var ReqModel={
      UserID: this.decodedUserData.UID,
      DatabaseID: this.userModel.databaseID,
      OrganizationID: this.userModel.OrganizationID,
      Base64String: this.imageSrc,
      FileName: this.FileName,
      FileExtention: this.FileExtention
    }   
    this.userService.getImageUlpoadURL(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.ImagePathURL = response.data;
          }
        }
      });
  }


  SaveUserDetails(formValues: any) {
    this.spinner=true;
    var dateFormated;
    if(formValues.dob=="" || formValues.dob==null || formValues.dob==undefined){
       dateFormated = null;     
    }else{
      var someDate = new Date(formValues.dob);
      someDate.setDate(someDate.getDate() + 1); //number  of days to add, e.x. 1 days
       dateFormated = someDate;
    }
    this.updateUserProfileform.markAsPristine();  
    var ReqModel={
      firstName: this.encryptionAlgo.set(this.reusableClass.encryptionKey,formValues.firstname),
      lastName: this.encryptionAlgo.set(this.reusableClass.encryptionKey,formValues.lastname),
      userName: this.userName,
      email: this.encryptionAlgo.set(this.reusableClass.encryptionKey,formValues.email),
      phone: this.encryptionAlgo.set(this.reusableClass.encryptionKey, this.phoneNumberExt + '' + formValues.phone),//this.encryptionAlgo.set(this.reusableClass.encryptionKey,formValues.phone),
      userProfileID: this.userProfileID,
      address:formValues.address,
      cityID: 0,
      cityName: "",
      stateID: 0,
      stateName: "",
      countryID: 0,
      countryName: "",
      zipCodeID: 0,
      zipCode: "",
      dateOfBirth:dateFormated, //(date.getDate() + 1),//(formValues.dob),
      title:formValues.title,
      timeZoneID: 0,
      timeZoneName: this.TimeZone,
      userID: this.currentUser.UID,
      profileImageUrl:this.ImagePathURL,
      organizationID: this.userModel.OrganizationID,
      isActive: true,
      emailConfirmed: true,
      phoneConfirmed: true,
      multiFactorAuth: true
    }
    this.userService.updateUserProfile(ReqModel).subscribe((response) => {
      if (response != undefined) {        
        this.responseHolder = response;
        this.loaderService.hide();  
        this.spinner=false;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.getUserDetailsManageUser();
          this.loaderService.hide();
          this.spinner=false;
          this.updateUserProfileform.markAsPristine();  
          this.toastr.success('User details update successfully.', '', {
            timeOut: 3000,
          });        
          this._dataSharingService.sendUpdateUserProfile(true);
        }else{
          this.loaderService.hide();
          this.spinner=false;
        }
      }else{
        this.loaderService.hide();
        this.spinner=false;
      }
    });
 }
       


  getShortName(fullName) {
    return fullName.split(' ').map(n => n[0]).join('');
  }


  // ==== Update Password ===== //

  updatePassword(formValues){
    this.UpdatePassword=false;
    if (formValues != undefined) {
      var username='';
      username= sessionStorage.getItem('email');
      var ReqModel={        
        username:this.encryptionAlgo.set(this.reusableClass.encryptionKey, username),
        currentPassword:this.isMasterPasswordLogin?null:this.encryptionAlgo.set(this.reusableClass.encryptionKey, formValues.currentPassword),
        newPassword:this.encryptionAlgo.set(this.reusableClass.encryptionKey, formValues.newPassword),
        userID: this.currentUser.UID,
        organizationID:Number(this.organizationId),
        isMasterPasswordLogin:this.isMasterPasswordLogin
      }     
      this.loaderService.show();
      this.commonService.changePassword(ReqModel).subscribe(response=>{
        if (response) {
          this.loaderService.hide();
          this.updatePasswordResponseHolder = response;
          if (this.updatePasswordResponseHolder.status == this.statusConst.statusSuccess) {
            this.updatePasswordForm.reset();
            this.UpdatePassword=false;   
            this.toastr.success("Password changed successfully.", '', {
              timeOut: 3000,
            });
          }
          else{
             this.updatePasswordForm.reset();
             this.UpdatePassword=false;
             this.loaderService.hide();
             this.toastr.warning(this.updatePasswordResponseHolder.message, '', {
              timeOut: 3000,
            });
          }
        }
        else {
          this.updatePasswordForm.reset();
          this.UpdatePassword=false;
          this.loaderService.hide();
        }
      });
    }
  }

   // To match password on confirm password input box
   Passwords(): void { 
    var newPassword= this.updatePasswordForm.controls['newPassword'].value.length;
    var confirmPassword= this.updatePasswordForm.controls['confirmPassword'].value.length;
    if(newPassword >= 8 && confirmPassword >= 8){
     if (this.updatePasswordForm.controls['newPassword'].value !== this.updatePasswordForm.controls['confirmPassword'].value) {
       this.UpdatePassword=false;
      // this.updatePasswordForm.controls['confirmPassword'].setErrors({ MatchPassword: true });        
     } else {
      if(this.updatePasswordForm.status.toLocaleLowerCase()=="valid"){
        this.UpdatePassword=true;
      }
       return null;
     }
    }else{
      this.UpdatePassword=false;
     // this.updatePasswordForm.controls['confirmPassword'].setErrors({ MatchPassword: true });       
    }      
   }

    // To match password on confirm password input box
    matchPassword(): void { 
     var newPassword= this.updatePasswordForm.controls['newPassword'].value.length;
     var confirmPassword= this.updatePasswordForm.controls['confirmPassword'].value.length;
     if(newPassword >= 8 && confirmPassword >= 8){
      if (this.updatePasswordForm.controls['newPassword'].value !== this.updatePasswordForm.controls['confirmPassword'].value) {
        this.UpdatePassword=false;
        //this.updatePasswordForm.controls['confirmPassword'].setErrors({ MatchPassword: true });        
      } else {
        if(this.updatePasswordForm.status.toLocaleLowerCase()=="valid"){
          this.UpdatePassword=true;
        }
       
        return null;
      }
     }else{
      this.UpdatePassword=false;
      // this.updatePasswordForm.controls['confirmPassword'].setErrors({ MatchPassword: true });       
     }      
    }

  @ViewChild(SignaturePad) signaturePad: SignaturePad;
 
  public signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
    'minWidth': 2,
    'canvasWidth': 630,
    'canvasHeight': 200
  };

  public signaturePadOptions1: Object = { // passed through to szimek/signature_pad constructor
    'minWidth': 2,
    'canvasWidth': 330,
    'canvasHeight': 200
  };

  ngAfterViewInit() {
    // this.signaturePad is now available
    //this.signaturePad.set('minWidth', 5); // set szimek/signature_pad options at runtime
    //this.signaturePad.clear(); // invoke functions from szimek/signature_pad API
  }
 
  drawComplete() {
    // will be notified of szimek/signature_pad's onEnd event    
  }
 
  drawStart() {
    // will be notified of szimek/signature_pad's onBegin event  
  }
 

  OpenSignPopup(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'selectTemplate',
    });
  }

  setSignInitialFontFamilyChange(e:any) {
    this.signInitialFontFamily=e;
  }

  createPin(){
    this.addEditPin =true;
    this.addPin =true;    
  }

  savePin(){
    this.addEditPin =false;
    this.pinAdded =true;    
  }

  forgotPin(){
    this.pinAdded =false;   
    this.addEditPin =true; 
  }

  Update2FactorAuth(event: any) {
    this.loaderService.show();
    var ReqModel = {     
      isMFA: event.checked,
      userID: this.currentUser.UID,
      organizationID:Number(this.organizationId),
      officeID:this.myOfficeID,
    }
     this.userService.setMFA(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.data == true) {
          this.toastr.success('Authentication set successfully.', '', {
            timeOut: 3000,
          });
          this.getUserDetailsManageUser();
          this.loaderService.hide();
        }else{
          this.loaderService.hide();
        }
      }else{
        this.loaderService.hide();
      }
    });
  }

  formDialog: FormGroup;
  spinnerIntegration:boolean=false;
  thirdPartyApiID:number=0;
  thirdPartyName:string="";
  responseHolder1:any=[]=[];

  openDialogIntegration(templateRef: TemplateRef<any>,app:any) {
    this.dialog.open(templateRef, {
      panelClass: 'addThirdParty',
    });
    this.formDialog = this.formBuilder.group({
      grantType: [''],      
      clientID: [''],      
      clientSecret:[''],           
      username: [''],    
      password: [''],    
    },);     
    this.thirdPartyApiID= app.thirdPartyApiID;
    this.thirdPartyName=app.thirdPartyApiName;
    if(this.thirdPartyApiID>0){
      this.GetSuperAdminThirdPartyApi();  
    }  
  } 
  
  GetSuperAdminThirdPartyApi() {
    this.loaderService.show();   
    var ReqModel = {
      ThirdPartyApiID:this.thirdPartyApiID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
    }
    this.userService.getSuperAdminThirdPartyApi(ReqModel).subscribe(response1 => {
      if (response1 != undefined) {
        this.loaderService.hide();
        if(response1.data!=null){
          this.responseHolder1 = response1.data;
          this.formDialog.controls['grantType'].setValue(this.responseHolder1.grant_type);
          this.formDialog.controls['clientID'].setValue(this.responseHolder1.client_id);
          this.formDialog.controls['clientSecret'].setValue(this.responseHolder1.client_secret);
          this.formDialog.controls['username'].setValue(this.responseHolder1.username);
          this.formDialog.controls['password'].setValue(this.responseHolder1.password);
        }               
      }
      else {        
      }
    });
  }

  close() {   
    this.formDialog.reset();
    this.dialog.closeAll();
  }

  AddUpdateIntegration(data) { 
    let ReqModel = {
      serviceID: this.thirdPartyApiID,//1,
      grantType: data.grantType,
      isVerified: true,
      clientID: data.clientID,
      clientSecret: data.clientSecret,
      username: data.username,
      password: data.password,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),         
      officeID:this.myOfficeID,
   }
   //return;
   this.loaderService.show();   
   this.spinnerIntegration=true;  
   this.formDialog.markAsPristine(); 
   this.userService.addUserService(ReqModel).subscribe(response => {
     if (response != undefined) {
       this.responseHolder = response;
       this.loaderService.hide();
       if (this.responseHolder.status == this.statusConst.statusSuccess) {
         this.spinnerIntegration=false;          
         this.toastr.success('Integration added successfully.', '', {
           timeOut: 3000,
         });
         this.getThirdPartyApplicationList();
         this.close();        
         this.loaderService.hide();        
       }else{        
         this.spinnerIntegration=false; 
         this.loaderService.hide(); 
       }
     }else{      
       this.spinner=false; 
       this.loaderService.hide(); 
     }
   });
  }

  ShowNoRecordFound:boolean=false;
  thirdPartyApplicationList:any=[]=[];

  getThirdPartyApplicationList() {
    this.loaderService.show();   
    var ReqModel = {
      isUser: true,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),  
      officeID: this.myOfficeID,   
    }
    this.userService.getUserProfileServices(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.thirdPartyApplicationList = this.responseHolder.data;         
          if(this.thirdPartyApplicationList!=null){
            this.ShowNoRecordFound=false;
          }else{
            this.ShowNoRecordFound=true;
           }     
        }
        else {
          this.ShowNoRecordFound=true;
          this.thirdPartyApplicationList=[];      
          this.loaderService.hide();
        }
      }
      else {
        this.ShowNoRecordFound=true;
        this.thirdPartyApplicationList=[];     
        this.loaderService.hide();
      }
    });
  } 
  
  showDetailLogo(app:any){
    if(app.apiLogo!=""){
      window.open(app.apiLogo, "_blank"); 
    }
  }

  showDetail(app:any){
    if(app.documentationUrl!=""){
      window.open(app.documentationUrl, "_blank"); 
    }
  }

  allNotifications = false;
  emailNotification = false;
  textNotification = false;
  inAppNotification = false;

  onToggleAll(): void {
    if (this.allNotifications) {
      this.emailNotification = true;
      this.textNotification = true;
      this.inAppNotification = true;
    } else {
      this.emailNotification = false;
      this.textNotification = false;
      this.inAppNotification = false;
    }
    this.AddUpdateUserNotificationPreferances();
  }

  onToggleEmail(): void {
    this.checkAllNotificationStatus();
    this.AddUpdateUserNotificationPreferances();
  }

  onToggleText(): void {
    this.checkAllNotificationStatus();
    this.AddUpdateUserNotificationPreferances();
  }

  onToggleInApp(): void {
    this.checkAllNotificationStatus();
    this.AddUpdateUserNotificationPreferances();
  }

  private checkAllNotificationStatus(): void {
    this.allNotifications = this.emailNotification && this.textNotification && this.inAppNotification;
  }

  AddUpdateUserNotificationPreferances() {
    this.loaderService.show();   
    var ReqModel =  {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),  
      officeID: this.myOfficeID, 
      UserNotificationPreferancesID: this.userNotificationPreferancesID,
      isText: this.textNotification,
      isEmail: this.emailNotification,
      isInApp: this.inAppNotification
  }
    this.userService.AddUpdateUserNotificationPreferances(ReqModel).subscribe(response => {
      
        this.responseHolder = response;
        this.userNotificationPreferancesID = this.responseHolder.data;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('Notification Preferances Added/Updated successfully.', '', {
            timeOut: 3000,
          });   
        }
        else {
          this.toastr.error('Failed to Add/Update Notification Preferances.', '', {
            timeOut: 3000,
          });   
        }
    });
  }

  linkCopied(){
    this.toastr.success('UserId copied.', '', {
    timeOut: 3000,
   });
  } 

}
